import React from "react";
import {Form} from 'antd';

import {EditableContext} from "../../context/EditableTable";

// Create individual form for each table row
const EditableRow = ({index, ...props}) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false} preserve={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

export default EditableRow;
